module.exports = __webpack_public_path__ + "img/deleteVideoWhite.b99911f0.svg";